import React, { useEffect, useRef, useState } from 'react';

export default function TtePassphraseModal({
  open,
  title = 'Tanda Tangan Elektronik',
  count = 1,
  signer,
  busy = false,
  onClose,
  onSubmit
}) {
  const [passphrase, setPassphrase] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    setPassphrase('');
    setConfirmed(false);
    if (open) setTimeout(() => inputRef.current?.focus(), 100);
  }, [open]);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!passphrase || !confirmed || busy) return;

    const value = passphrase;
    try {
      await onSubmit(value);
    } finally {
      setPassphrase('');
    }
  };

  return (
    <div className="tte-modal-backdrop" role="dialog" aria-modal="true">
      <form className="tte-modal" onSubmit={submit} autoComplete="off">
        <div className="tte-modal__head">
          <div>
            <small>TTE BSrE</small>
            <h3>{title}</h3>
          </div>
          <button type="button" onClick={onClose} disabled={busy}>×</button>
        </div>

        <div className="tte-modal__body">
          <div className="tte-signer-card">
            <span>Penandatangan</span>
            <strong>{signer?.nama_lengkap || '-'}</strong>
            <small>{signer?.jabatan || ''}</small>
          </div>

          <div className="tte-info">
            {count} dokumen akan diproses. Periksa dokumen sebelum menandatangani.
          </div>

          <label className="tte-field">
            <span>Passphrase Sertifikat Elektronik</span>
            <input
              ref={inputRef}
              type="password"
              value={passphrase}
              onChange={(e) => setPassphrase(e.target.value)}
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck={false}
              disabled={busy}
              placeholder="Masukkan passphrase"
              required
            />
            <small>
              Passphrase hanya digunakan untuk proses ini dan tidak disimpan oleh SIPAK.
            </small>
          </label>

          <label className="tte-check">
            <input
              type="checkbox"
              checked={confirmed}
              onChange={(e) => setConfirmed(e.target.checked)}
              disabled={busy}
            />
            <span>Saya sudah memeriksa dokumen yang akan ditandatangani.</span>
          </label>
        </div>

        <div className="tte-modal__actions">
          <button type="button" className="tte-btn tte-btn--ghost" onClick={onClose} disabled={busy}>
            Batal
          </button>
          <button
            type="submit"
            className="tte-btn tte-btn--primary"
            disabled={busy || !passphrase || !confirmed}
          >
            {busy ? 'Memproses...' : 'Tanda Tangani'}
          </button>
        </div>
      </form>
    </div>
  );
}
